export const FooterItems = [
    // {
    //     title: "Our Services",
    //     url: "/services"
    // },
    // {
    //     title: "Private Policy",
    //     url: "/policy"
    // },
    // {
    //     title: "License",
    //     url: "/license"
    // },
]